import { useEffect, useState } from 'react';
import { getAccessToken } from '../helpers';
import { formsLibrary } from '../../../forms-library.config';

export function useFetchPlanDetailsData(
  planType: string,
  setPlanDetailsLoading: any,
  accessToken: string,
) {
  const [apiData, setApiData] = useState(null);
  const [errMsg, setErrMsg] = useState(null);

  const planDetailsKeys = JSON.parse(
    sessionStorage.getItem('planDetailsKeys') || '{}',
  );
  const planInfo = planDetailsKeys?.filter(
    (plan: any) => plan.planType.toLowerCase() === planType,
  )[0];
  const { planYear, groupNumber, productNumber } = planInfo;

  const config = formsLibrary.getConfig();
  const { HIGHMARK_API_URL, useCurrentRegionUbkHeader } = config;
  const currentUbk: any = useCurrentRegionUbkHeader() || null;
  const ubkValue = currentUbk?.headers?.Brandubk || null;
  const url = `${HIGHMARK_API_URL}/digital/v1/members/benefits/plan/detail?planYear=${planYear}&groupNumber=${groupNumber}&planType=${planType}&productNumber=${productNumber}`;
  useEffect(() => {
    setPlanDetailsLoading(true);
    getAccessToken(url, ubkValue, '', accessToken).then((result: any) => {
      const planDetailsData = result?.plan;
      const errData = result?.errMsg;
      setPlanDetailsLoading(false);
      if (planDetailsData) {
        setApiData(result);
      } else if (errData) {
        setErrMsg(errData);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return [apiData, errMsg];
}
